import { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getProjects, STATUS_KEYS } from "../../i18n/translations";
import { useLanguage } from "../../i18n/LanguageContext";
import ProjectModal from "./ProjectModal";

const LAYOUTS = {
  1: [{ span: "md:col-span-12", height: "h-[420px] md:h-[560px]" }],
  2: [
    { span: "md:col-span-7", height: "h-[440px] md:h-[560px]" },
    { span: "md:col-span-5", height: "h-[440px] md:h-[560px]" },
  ],
  3: [
    { span: "md:col-span-12", height: "h-[440px] md:h-[520px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
  ],
  4: [
    { span: "md:col-span-7", height: "h-[440px] md:h-[520px]" },
    { span: "md:col-span-5", height: "h-[440px] md:h-[520px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
  ],
  5: [
    { span: "md:col-span-7 md:row-span-2", height: "h-[520px] md:h-[680px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
  ],
  6: [
    { span: "md:col-span-7 md:row-span-2", height: "h-[520px] md:h-[680px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
  ],
  7: [
    { span: "md:col-span-7 md:row-span-2", height: "h-[520px] md:h-[680px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[460px]" },
    { span: "md:col-span-6", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-6", height: "h-[380px] md:h-[420px]" },
  ],
  8: [
    { span: "md:col-span-7 md:row-span-2", height: "h-[520px] md:h-[680px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-6", height: "h-[420px] md:h-[460px]" },
    { span: "md:col-span-6", height: "h-[420px] md:h-[460px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
  ],
  9: [
    { span: "md:col-span-7 md:row-span-2", height: "h-[520px] md:h-[680px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-4", height: "h-[400px] md:h-[440px]" },
    { span: "md:col-span-4", height: "h-[400px] md:h-[440px]" },
    { span: "md:col-span-4", height: "h-[400px] md:h-[440px]" },
    { span: "md:col-span-4", height: "h-[400px] md:h-[440px]" },
    { span: "md:col-span-4", height: "h-[400px] md:h-[440px]" },
    { span: "md:col-span-4", height: "h-[400px] md:h-[440px]" },
  ],
  10: [
    { span: "md:col-span-7 md:row-span-2", height: "h-[520px] md:h-[680px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-5", height: "h-[380px] md:h-[330px]" },
    { span: "md:col-span-6", height: "h-[420px] md:h-[460px]" },
    { span: "md:col-span-6", height: "h-[420px] md:h-[460px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-4", height: "h-[380px] md:h-[420px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[440px]" },
    { span: "md:col-span-6", height: "h-[400px] md:h-[440px]" },
  ],
};

function getLayout(count) {
  if (count <= 0) return [];
  if (count > 10) return LAYOUTS[10];
  return LAYOUTS[count];
}

function ProjectTile({ project, span, height, index, onOpen, cta }) {
  return (
    <motion.button
      type="button"
      onClick={() => onOpen(project)}
      data-testid={`project-card-${project.id}`}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.06, ease: "easeOut" }}
      className={`group relative text-left col-span-1 ${span} ${height} overflow-hidden bg-[#0F0F0F] border border-white/5 hover:border-[#C5A059]/40 transition-colors duration-500`}
    >
      {project.image ? (
        <img
          src={project.image}
          alt={project.title}
          className={`absolute inset-0 w-full h-full transition-transform duration-[1200ms] ease-out group-hover:scale-105 ${
            project.fit === "contain"
              ? "object-contain bg-[#f4e6d8]"
              : "object-cover"
          }`}
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a1814] via-[#0d0c0a] to-[#050505]">
          <div className="absolute inset-0 flex items-center justify-center opacity-20">
            <img
              src="/logo.png"
              alt=""
              aria-hidden
              className="h-32 w-32 object-contain"
            />
          </div>
        </div>
      )}

      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
      <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-700" />

      <div className="relative h-full flex flex-col justify-end p-6 md:p-8 z-10">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-[10px] tracking-[0.32em] uppercase text-[#C5A059]">
            {project.status}
          </span>
        </div>
        <h3 className="font-display text-[#F5F5F0] text-2xl md:text-3xl lg:text-4xl leading-tight">
          {project.title}
        </h3>
        <p className="mt-2 text-[12px] tracking-[0.18em] uppercase text-[#A3A3A3]">
          {project.format}
        </p>

        <div className="mt-5 flex items-center gap-2 text-[#C5A059] opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
          <span className="text-[11px] tracking-[0.3em] uppercase">{cta}</span>
          <svg width="22" height="8" viewBox="0 0 22 8" fill="none" aria-hidden>
            <path
              d="M0 4h20M16 1l4 3-4 3"
              stroke="currentColor"
              strokeWidth="1"
            />
          </svg>
        </div>
      </div>
    </motion.button>
  );
}

export default function Catalogue() {
  const { lang, t } = useLanguage();
  const [active, setActive] = useState(null);
  const [tab, setTab] = useState("developpement");

  const projects = useMemo(() => getProjects(lang), [lang]);
  const statusKeys = STATUS_KEYS[lang];

  const counts = useMemo(
    () => ({
      developpement: projects.filter((p) => p.status === statusKeys.developpement).length,
      diffusee: projects.filter((p) => p.status === statusKeys.diffusee).length,
    }),
    [projects, statusKeys],
  );

  const filtered = useMemo(() => {
    const match = statusKeys[tab];
    return projects.filter((p) => p.status === match);
  }, [projects, tab, statusKeys]);

  const layout = getLayout(filtered.length);

  const TABS = [
    { id: "developpement", label: t.catalogue.tabs.developpement },
    { id: "diffusee", label: t.catalogue.tabs.diffusee },
  ];

  return (
    <section
      id="catalogue"
      data-testid="catalogue-section"
      className="relative py-24 md:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12 md:mb-16">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#C5A059]" />
              <span className="tcp-eyebrow">{t.catalogue.eyebrow}</span>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mb-10 md:mb-14 flex flex-wrap items-center gap-2 md:gap-3 border-b border-white/10 pb-4"
          data-testid="catalogue-tabs"
        >
          {TABS.map((tt) => {
            const isActive = tab === tt.id;
            const count = counts[tt.id] ?? 0;
            return (
              <button
                key={tt.id}
                type="button"
                onClick={() => setTab(tt.id)}
                data-testid={`catalogue-tab-${tt.id}`}
                aria-pressed={isActive}
                className={`relative inline-flex items-center gap-3 px-4 md:px-5 py-2.5 text-[11px] md:text-[12px] tracking-[0.28em] uppercase transition-colors duration-300 ${
                  isActive
                    ? "text-[#050505] bg-[#C5A059]"
                    : "text-[#A3A3A3] hover:text-[#F5F5F0]"
                }`}
              >
                <span>{tt.label}</span>
                <span
                  className={`text-[10px] tracking-[0.12em] tabular-nums ${
                    isActive ? "text-[#050505]/70" : "text-[#9c9b94]"
                  }`}
                >
                  {String(count).padStart(2, "0")}
                </span>
              </button>
            );
          })}
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-fr gap-4 md:gap-6">
          <AnimatePresence mode="popLayout">
            {filtered.map((p, i) => (
              <ProjectTile
                key={p.id}
                project={p}
                span={layout[i]?.span ?? "md:col-span-6"}
                height={layout[i]?.height ?? "h-[420px]"}
                index={i}
                onOpen={setActive}
                cta={t.catalogue.cta}
              />
            ))}
          </AnimatePresence>
        </div>
      </div>

      <ProjectModal project={active} onClose={() => setActive(null)} />
    </section>
  );
}
